// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(min-width: 601px)";
var _3 = "root-YLTlN";
var _4 = "controls-10c9x";
var _5 = "confirmButton-2YQX6";
export { _1 as "__esModule", _2 as "exclude_mobile", _3 as "root", _4 as "controls", _5 as "confirmButton" }
export default { "__esModule": _1, "exclude_mobile": _2, "root": _3, "controls": _4, "confirmButton": _5 }
